import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {NgClass} from "@angular/common";


/**
 * Dialog component for selecting a damping factor.
 *
 * Displays predefined percentage values and returns the selected factor
 * to the caller when a value is clicked.
 */
@Component({
  selector: 'colimo-damping-dialog',
  templateUrl: './damping-dialog.component.html',
  imports: [
    NgClass,
    MatDialogContent
  ],
  styleUrl: './damping-dialog.component.scss'
})
export class DampingDialogComponent {

  public factors: number[] = [0, 10, 20, 30, 40, 50 , 60, 70, 80, 90, 100];

  constructor(private dialogRef: MatDialogRef<DampingDialogComponent>,
              @Inject(MAT_DIALOG_DATA)
              public data: {
                selectedDampingFactor: number;
              }) {}


  /**
   * Closes the dialog and returns the selected damping factor.
   *
   * @param factor Selected damping factor (percentage value)
   */
  public selectFactor(factor: number) {
    this.dialogRef.close(factor);
  }

}
